import * as XLSX from "xlsx";

const fmtNum = (n) => Number(n || 0);

const formatDateIndo = (dateStr) => {
  if (!dateStr) return "-";
  try {
    const d = new Date(dateStr);
    return d.toLocaleDateString("id-ID", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
  } catch {
    return dateStr;
  }
};

export async function exportProfitSalesToExcel({
  storeInfo = {},
  reportData = {},
  startDate = "",
  endDate = "",
}) {
  const transactions = reportData?.transactions || [];
  const storeName = storeInfo.name || localStorage.getItem("tenantName") || "Sinar Abadi";
  const storeAddress = storeInfo.address || "";

  const dataRows = [];

  // Title info
  dataRows.push([storeName.toUpperCase()]);
  if (storeAddress) dataRows.push([storeAddress]);
  dataRows.push(["LAPORAN PROFIT PENJUALAN"]);
  dataRows.push([`Periode: ${startDate || "-"} s/d ${endDate || "-"}`]);
  dataRows.push([]);

  // Summary Row
  dataRows.push([
    "TOTAL PENJUALAN",
    fmtNum(reportData.total_sales),
    "TOTAL MODAL",
    fmtNum(reportData.total_modal),
    "TOTAL PROFIT",
    fmtNum(reportData.total_profit),
    "MARGIN",
    `${Number(reportData.profit_margin_percent || 0).toFixed(2)}%`,
  ]);
  dataRows.push([]);

  // Header Table
  dataRows.push([
    "No Invoice",
    "Tanggal",
    "Pelanggan",
    "Nama Item",
    "Qty",
    "Harga Jual",
    "Modal",
    "Total Amount",
    "Profit",
  ]);

  transactions.forEach((tx) => {
    const items = tx.items || [];
    const txNo = tx.transaction_no || tx.transaction_number || "-";
    const txDate = formatDateIndo(tx.date || tx.order_date);
    const customer = tx.customer || "Pelanggan Umum";
    const isReturn = Boolean(tx.is_return || tx.isReturn);
    const invoiceLabel = isReturn 
      ? `${txNo} (Retur${tx.reference_number || tx.referenceNumber ? ` Ref: ${tx.reference_number || tx.referenceNumber}` : ""})`
      : txNo;

    items.forEach((itm, idx) => {
      dataRows.push([
        idx === 0 ? invoiceLabel : "",
        idx === 0 ? txDate : "",
        idx === 0 ? customer : "",
        `${itm.product_name || "-"}${Number(itm.discount_amount || 0) > 0 ? ` | Diskon Item -${fmtNum(itm.discount_amount)}` : ""}${Number(itm.additional_cost || 0) > 0 ? ` | Biaya Tambahan Item +${fmtNum(itm.additional_cost)}` : ""}`,
        fmtNum(itm.quantity),
        fmtNum(itm.unit_price),
        fmtNum(itm.purchase_price),
        fmtNum(itm.total_price),
        fmtNum(itm.profit),
      ]);
    });

    // Subtotal Row per invoice
    dataRows.push([
      "",
      "",
      "",
      isReturn ? `Sub Total Retur (${txNo}):` : `Sub Total (${txNo}):`,
      "",
      "",
      "",
      fmtNum(tx.subtotal),
      fmtNum(tx.profit),
    ]);
    dataRows.push([]);
  });

  // Grand Total Row
  dataRows.push([
    "TOTAL KESELURUHAN",
    "",
    "",
    "",
    "",
    "",
    "",
    fmtNum(reportData.total_sales),
    fmtNum(reportData.total_profit),
  ]);

  const ws = XLSX.utils.aoa_to_sheet(dataRows);

  // Column widths
  ws["!cols"] = [
    { wch: 22 }, // No Invoice
    { wch: 14 }, // Tanggal
    { wch: 24 }, // Pelanggan
    { wch: 38 }, // Nama Item
    { wch: 10 }, // Qty
    { wch: 16 }, // Harga Jual
    { wch: 16 }, // Modal
    { wch: 18 }, // Total Amount
    { wch: 16 }, // Profit
  ];

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Profit Penjualan");

  const fileName = `Laporan_Profit_Penjualan_${startDate || "All"}_sd_${endDate || "All"}.xlsx`.replace(/\s+/g, "_");
  XLSX.writeFile(wb, fileName);
}
